import { ApiServiceV1 } from '@services/api.service';

export default {
  async getLocations() {
    const { data } = await ApiServiceV1.get('location');
    return data || [];
  },
  createLocation({ name, route }) {
    return ApiServiceV1.post('location', { name, route });
  },
};
